<template>
  <div
    class="project-card text-brand-cream p-5 flex flex-col justify-between min-h-[320px]"
    :class="{ featured: featured }"
  >
    <div class="flex-1 flex flex-col relative z-[1]">
      <div class="flex items-center justify-between gap-2 mb-3">
        <span
          v-if="label"
          class="project-label self-start text-xs tracking-wide uppercase px-2 py-1 rounded-sm"
        >
          {{ label }}
        </span>
        <span
          v-if="note"
          class="sketch-label text-brand-muted/90"
          aria-hidden="true"
        >
          {{ note }}
        </span>
      </div>

      <h3 class="text-xl font-bold tracking-tight leading-snug">{{ title }}</h3>
      <p class="text-sm mt-3 text-brand-muted leading-relaxed flex-1">{{ description }}</p>

      <div class="flex flex-wrap gap-2 mt-4">
        <span
          v-for="tech in technologies"
          :key="tech"
          class="project-tech text-xs px-2 py-1 rounded-sm"
        >
          {{ tech }}
        </span>
      </div>
    </div>

    <div class="flex items-center mt-5 space-x-2 relative z-[1]">
      <a
        v-if="github"
        :href="github"
        target="_blank"
        rel="noopener"
        class="project-icon-btn inline-flex items-center justify-center rounded-full w-8 h-8"
        aria-label="GitHub"
      >
        <i class="fab fa-github"></i>
      </a>
      <span v-if="featured" class="sketch-dev text-xs ml-1" aria-hidden="true">↗ peek the code</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    description: String,
    technologies: Array,
    thumbnail: String,
    github: String,
    label: String,
    featured: {
      type: Boolean,
      default: false,
    },
    note: {
      type: String,
      default: "",
    },
  },
};
</script>
